<template>

    <div class="agreement-content">
        <h2 class="agreement-title">数据资产全过程AI服务平台</h2>
        <h2 class="agreement-title">用户服务协议</h2>
        <h3>尊敬的用户：</h3>
        <p>在您使用数据资产全过程AI服务平台提供的服务之前，请您仔细阅读本服务协议的全部内容<strong>（特别是以粗体及/或下划线标注的内容）</strong>。如果您对本协议的条款有疑问的，请通过数据资产全过程AI服务平台相关网页上的联系方式进行询问，本平台将向您解释条款内容。<strong>如果您不同意本协议的任意内容，或者无法准确理解本平台对条款的解释，请不要进行后续操作。您若点击同意则表示您已同意本协议内容，本协议即构成您与数据资产全过程AI服务平台运营者之间具有约束力的法律文件。</strong>
        </p>

        <h3>一、定义</h3>
        <p>1.1. 除非本协议中另有特殊说明外，下列词语在本协议中均应具有以下特定涵义：</p>
        <p>1.2. 本平台：是指由保定市数据资产登记评价中心有限公司运营的、面向用户提供数据（产品）登记、数据（产品）交易市场、大数据相关服务及解决方案、大数据需求发布及招标以及其他大数据相关服务的网络平台。本平台下设多个类目，保定市数据资产登记评价中心有限公司可能会根据自身的经营发展情况，适时调整本平台名称、网址及其他展示要素，并通过公告、站内信、邮件及其他有效方式通知平台用户。该等调整不会影响保定市数据资产登记评价中心有限公司与平台用户之间在本协议项下的权利义务关系。
        </p>
        <p>1.3. 平台运营方：特指保定市企服数据资产认证登记评价中心有限公司。</p>
        <p>1.4. 平台用户：是指同意《数据资产全过程AI服务平台用户服务协议》的全部规定，经自愿申请，而获得数据资产全过程AI服务平台网站账户的个人或者单位。在使用本平台服务之前，首先应当注册为数据资产全过程AI服务平台用户，拥有数据资产全过程AI服务平台用户账户（下称“用户账户”）。
        </p>
        <p>1.5. 本平台交易标的（或称“交易标的”）：是指供方在本平台发布的所有数据（产品）和大数据相关服务的统称。</p>
        <p>1.6. 本平台供方（或称“供方”）：是指通过本平台向需方销售及/或提供数据（产品）和大数据相关服务的企业。</p>
        <p>1.7. 本平台需方（或称“最终需方”、“需方”）：是指通过本平台，购买、获取供方提供的数据（产品）和大数据相关服务的企业。</p>

        <h3>二、协议的主体、生效和效力范围</h3>
        <p>2.1 本协议的主体包括本平台运营方、平台用户，本服务协议是平台运营方与用户之间所达成的基本条款、条件和规则，属于有效合约。</p>
        <p>2.2 用户使用本平台服务时，本平台将提示用户通过签署书面协议、网络页面勾选确认/或点击确认、邮件确认或其他平台运营方认可的方式，选择接受本协议。</p>
        <p>2.3 本协议自平台用户以上述任一方式确认接受之时起，或用户实际开始接受本平台的服务（包括但不限于供方登记、上架、售卖交易标的；需方购买交易标的及发布需求信息；用户使用平台查询等其他服务）之时起（以时间在先者为准）生效。用户一经接受，即表示同意接受本协议的全部约定内容。
        </p>
        <p>2.4 本协议内容包括协议正文、附件以及所有平台运营方已经发布的或未来本平台可能发布的各类业务规范、活动规则、通知、公告等（以下统称为“本平台规则”）。所有本平台规则为本协议不可分割的组成部分，与本协议正文具有同等法律效力。
        </p>
        <p>2.5 如果用户使用本平台目前或将来提供的特定服务，同时还应接受适用于那些特定服务的条款、准则和条件（下称“特殊条款”），本平台将以书面协议、网页提示、网站公告等形式向用户明示这些特殊条款。如本协议与特殊条款的约定不一致的，则以特殊条款的约定为准。
        </p>
        <p>2.6 本平台有权根据需要，不时的制定、修改本协议和/或各类本平台规则，有权将本协议项下的权利义务转让给关联第三方。如有变更，本平台将以网页公示的方式进行公告，不再单独通知。变更后的协议和本平台规则，及/或权利义务转让，一经公布即自动生效，成为本协议的一部分。如用户不同意相关变更，应当立即停止使用本平台的服务；如继续使用本平台的相关服务的，则视为对修改后的协议和规则，及/或权利义务的转让不持异议并同意遵守。
        </p>

        <h3>三、本平台的服务与支持</h3>
        <p>3.1. 本平台将为用户开展以下活动，提供技术平台支持及服务：</p>
        <p>3.1.1. 根据<a href="javascript:void(0);" @click="previewFile('ManagementMeasures_Watermark.pdf')">《数据（产品）登记规则》</a>中的内容提供数据（产品）登记服务，管理办法详情可在实名认证后通过本平台下载。</p>
        <p>3.1.2. 供方发布交易标的、需方浏览供方的交易标的；</p>
        <p>3.1.3. 供方与需方就相关交易标的进行沟通，达成交易意向；</p>
        <p>3.1.4. 供方与需方进行并完成交易；</p>
        <p>3.1.5. 对交易对象、平台交易标的进行投诉；</p>
        <p>3.1.6. 本平台或第三方合作公司通过本平台提供大数据业务的相关服务及应用解决方案，如数据清洗、建模、数据中台、针对具体场景的应用等；另外本平台可以提供大数据相关需求的发布、招标、大赛及论坛的举办等服务。</p>
        <p>3.1.7. 参加本平台组织的活动；</p>
        <p>3.1.8. 使用本平台提供的其他配套服务，包括但不限于信息服务及技术服务。</p>
        <p>3.1.9. 如本平台提供的一般性服务无法满足需方的需求，本平台愿意为需方提供特殊定制服务。需方可联系平台客服咨询定制服务相关信息。</p>
        <p>3.2. 本平台不会为用户提供如下支持或服务：</p>
        <p>3.2.1. 用户之间通过本平台达成交易过程中，所产生的应纳税赋由用户自行承担，如交易过程中用户与平台运营方达成了相关协议的，以相关协议为准。</p>
        <p>3.2.2. 用户之间通过本平台达成交易过程中的一切硬件、软件、服务及其它方面的费用，均由用户自行承担；</p>
        <p>3.2.3. 除非法律法规明确规定或事先明示外，本平台不会就供方所售卖或提供的交易标的，单独或者与供方共同承担售后、维护、升级等责任，本平台也不会对此做出任何担保或承诺。相应的责任、担保或承诺，根据交易各方达成的相应采购协议、代理协议、合作协议的约定履行。
        </p>
        <p>3.3.1. 因需方购买供方的交易标的行为而产生的法律关系及法律纠纷，适用供方与需方之间另行达成的协议条款。</p>
        <p>3.3.2. 平台运营方与用户之间，因就本平台相关的采购、代理、合作等关系所产生的权利义务，应按照平台运营方与用户之间另行达成的相应采购协议、代理协议、合作协议的约定履行。</p>
        <p>3.3. 为维护交易秩序和促进各方合法权益，本平台有权进行如下活动：</p>
        <p>3.3.3. 对用户的注册信息及销售行为、服务提供行为，或购买行为、使用行为等进行查询；</p>
        <p>3.3.4. 通过邮件、短信、电话、网站通知或声明等形式，向用户发送订单信息、促销活动、售后服务、客户服务、通知公告等告知信息；</p>
        <p>3.3.5. 当发现用户的注册信息或销售行为、服务提供行为，或购买行为、使用行为等中存在任何问题时，向其采取包括但不限于发出询问及要求改正的通知、删除违规信息、禁言、限制订购、关闭订单、冻结账户、下架交易标的、暂停、关闭平台账户、终止服务等限制性措施，如涉及违法犯罪的，将移交司法机关。
        </p>
        <p>3.3.6. 按照法律法规的规定，或应政府部门（包括司法及行政部门）的要求，向其提供用户的身份信息和交易记录等必要信息；如用户涉嫌侵犯他人知识产权等合法权益的，在初步判断涉嫌侵权行为存在的情况下，本平台将在收到权利人通知后，将该通知转送相关用户，并有权根据构成侵权的初步证据和服务类型采取删除、屏蔽等必要措施。；
        </p>
        <p>3.3.7. 如用户之间，在使用本平台服务的过程中发生纠纷，任一方或双方共同均可将纠纷提交本平台要求调处时，本平台有权根据单方判断做出调处决定。用户理解并同意，本平台并非司法机构，仅能以普通第三方的身份对证据进行鉴别，本平台对争议的调处完全是基于用户不可撤销的授权，其无法保证争议处理结果符合其期望，也不对争议调处结论承担任何责任。
        </p>
        <p>3.3.8. 本平台将在现有技术上维护正常运行，并努力提升和改进技术，使用户的交易活动和其他行为得以顺利进行，用户理解并同意。</p>
        <p>3.3.9. 鉴于网络服务的特殊性，本平台的部分或全部的网络服务可能会变更、中断，但本平台将尽合理范围内的最大努力，通知用户采取必要措施以减少由此造成的影响。</p>
        <p>3.3.10. 本平台及/或相关的设备需要定期不定期的进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，本平台无需为此承担任何责任。</p>
        <h3>四、用户的承诺与义务</h3>
        <p>4.1. 用户在本平台上的活动中，应当遵守以下基本准则：</p>
        <p>4.1.1. 不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</p>
        <p>4.1.2. 不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
        <p>4.1.3. 不得利用本平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
        <p>4.1.4. 不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；</p>
        <p>4.1.5. 不得使用任何装置、软件或例行程序，干扰或试图干扰本平台的正常运转，不得非法侵入保定市数据资产登记评价中心有限公司及国家的互联网系统；</p>
        <p>4.1.6. 不得违反中国有关法律法规，非法向境外传输资料信息的；</p>
        <p>4.1.7. 不得进行其他影响或可能影响国家安全、社会公共秩序、他人合法权益的行为。</p>
        <p>4.2. 用户在通过本平台进行交易的过程中，承诺遵守以下义务：</p>
        <p>4.2.1. 遵守国家法律、法规等规范性文件及各项本平台规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不偷逃应缴税费，不违反本协议及相关本平台规则；</p>
        <p>4.2.2. 在与其他用户的交易过程中，遵守诚实信用原则，不采取不正当竞争行为，不扰乱网上交易的正常秩序，不从事与交易无关的行为；</p>
        <p>4.2.3. 不发布国家禁止销售的或限制销售（已获得合法许可的除外）的、涉嫌侵犯他人知识产权或其它合法权益的、违背社会公共利益或公共道德或本平台认为不适合销售的，或其他涉嫌违法或违反本协议及各类本平台规则的交易标的或服务信息。
        </p>
        <p>4.2.4. 不以虚构或歪曲事实的方式不当评价其他用户，不采取不正当方式制造或提高自身的商誉或形象；</p>
        <p>4.2.5. 不转卖或变相转卖平台账户及账户内的代金券、优惠券、折扣或其他本平台优惠待遇等，不得为获取优惠、折扣或其他利益而注册账户、进行下单或其他非正常的消费行为；</p>
        <p>4.2.6. 不利用任何非法手段获取其他用户或其他权利人的个人信息，不得将其他用户或其他权利人信息用于任何营利或非营利目的，不得泄露其他用户或其他权利人的个人隐私；</p>
        <p>4.2.7. 不对本平台上的任何数据作商业性利用，包括但不限于在未经本平台事先书面同意的情况下，以复制、传播等任何方式使用本平台展示的资料。</p>

        <h3>五、知识产权政策</h3>
        <p>5.1. 本平台上的所有内容诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件、商标都是平台运营方或其内容提供者（包括平台用户）的财产，受中国和国际版权法的保护。未经平台运营方或其内容提供者的合法授权或许可，不得以任何目的对本平台的全部网页或其任何部分进行复制、复印、仿造、出售、转售、访问、或以其他方式加以利用。
        </p>
        <p>5.2. 平台用户了解并同意，用户在本平台上发布的各类信息（包括但不限于身份信息、交易标的及服务信息、评论等），本平台拥有永久的免费使用权，并有权在全球范围内全部或部分地使用、复制、修订、改写、发布、翻译和展示。但涉及用户个人敏感信息的，或用户在发布信息的同时声明全部或部分保留的，该等使用行为不得违反国家隐私保护法规的规定，或超出用户声明保留的范围。
        </p>
        <p>5.3. 用户对其在本平台上售卖或提供的交易标的，拥有合法权利，未经用户或合法授权人许可，任何人不得以任何目的进行复制、仿造、出售、转售、或以其他方式加以利用，亦不得予以修改、反向工程、分拆、制作衍生作品、或散发。
        </p>
        <p>5.4. 保定市数据资产登记评价中心有限公司对本平台的运营数据，拥有全部权利。前述运营数据包括但不限于用户信息、用户列表、用户关系、用户使用行为、交易数据、订单数据等。但上述运营数据如涉及用户敏感信息的，保定市数据资产登记评价中心有限公司应遵守相应的隐私权保护政策。未经保定市数据资产登记评价中心有限公司事先书面同意，任何人得为任何目的擅自保存、备份、泄露、使用或授权他人使用前述运营数据。
        </p>
        <p>5.5. 尊重知识产权是本平台遵循的基本准则，平台用户应遵守前述义务，不得侵犯他人的合法权利。如有违反，侵权人应向被侵害的合法权利人，及本平台承担损害赔偿责任。</p>

        <h3>六、隐私权政策</h3>
        <p>6.1. 本平台声明并承诺：</p>
        <p>6.1.1. 不会向任何人出售或出借用户的信息，除非事先得到用户的许可。</p>
        <p>6.1.2. 不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的信息。</p>
        <p>6.1.3. <strong>为服务用户之目的，平台运营方可能通过使用用户的信息，向其提供服务，包括但不限于向用户发出产品和服务信息，或者与平台运营方的合作伙伴共享信息以便他们向平台用户发送有关其产品和服务的信息（后者需得到用户的事先同意）。</strong>
        </p>
        <p>6.2. 平台运营方将在下述情况下部分或全部披露用户的信息：</p>
        <p>6.2.1. 经用户同意，向第三方披露；</p>
        <p>6.2.2. 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
        <p>6.2.3. 如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；</p>
        <p>6.2.4. 为提供用户所要求的应用，而必须和第三方分享用户的信息；</p>
        <p>6.2.5. 其它平台运营方根据法律或者网站政策认为合适的披露。</p>
        <p>6.2.6. 需方理解并同意，其向本平台供方提交订单、购买交易标的的行为，将被视为需方同意向供方披露相关信息，用以接受供方向其提供交易标的、售后服务、客户服务、市场营销或其他必要事项，供方有权以履行上述事宜为目的联系需方。</p>
        <p>6.2.7. <strong>用户理解并同意，本平台可以利用平台内的运营数据包括但不限于用户信息、用户列表、用户关系、用户使用行为、交易数据、订单数据等内容在不违反法律法规和不泄露用户隐私及商业秘密的情况下进行统计研究、产品研发、平台升级等操作，用于更好的服务平台用户。</strong></p>

        <h3>七、责任限制</h3>
        <p>7.1. 不论在何种情况下，对由于计算机病毒、信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务，本平台均不承担责任。
        </p>
        <p>7.2. 本平台不能控制双方行为的合法性、有效性及工具的真实性、合法性和有效性，亦不对由此产生的后果承担任何责任。例如用户发布的任何准确或不正确的内容，以及交易方履行其在协议项下的各项义务的能力。</p>
        <p>7.3. 您应注意到，以欺诈手段通过平台审核进行交易的风险是客观存在的，如交易双方中有一方交易标的的知识产权、准确性、安全性和完整性是通过欺诈手段通过了平台的审核，平台不会承担需方因使用这些交易标的对自己和他人造成任何形式的损失或伤害的责任，但是平台会协助进行维权活动。
        </p>
        <p>7.4. 在任何情况下，本平台均不对任何间接性、后果性、惩戒性、偶然性、特殊性或刑罚性的损害，包括用户使用本平台服务而遭受的利润损失，承担责任（即使已被告知该等损失的可能性）。</p>

        <h3>八、法律、规则的适用与纠纷管辖</h3>
        <p>8.1. 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
        <p>8.2. 本协议是调整本平台与用户之间权利义务关系的基本规范。用户在使用本平台下设各类目的具体服务时，还须遵循适用于该类服务的特殊条款。本平台会与相关用户另行确认或书面签署这些特殊条款。如本协议与特殊条款不一致或有冲突，则特殊条款具有优先效力。
        </p>
        <p>8.3. 本协议履行过程中，如各方当事人之间发生纠纷的，首先应通过友好协商方式解决。<strong>如果协商未成的，任一方均可向本平台运营方所在地人民法院起诉。</strong></p>

        <h3>九、意见以及建议</h3>
        <p>9.1. 用户对数据资产全过程AI服务平台的服务有任何意见或建议，可通过数据资产全过程AI服务平台官方网站中相关联系方式反馈，数据资产全过程AI服务平台愿意倾听并尊重每一位用户的意见，并将尽力为用户提供最优质的服务。
        </p>

        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/page/downloadFile"  :can-download="false" />
    </div>

</template>

<script>

import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'UserAgreement',
    components: {
        FilePreview
    },
    methods: {
        // 判断文件是否可预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },

        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },

        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    {}, // customParams
                    false // canDownload: false 表示不可下载
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },
    },

}

</script>

<style scoped>


a {
    color: #1E88E5;
    text-decoration: none;
}

a:hover {
    color: #0d47a1;
    text-decoration: underline;
}

.agreement-content {
    padding: 0;
    line-height: 1.8;
    color: #333;
    font-family: "Microsoft YaHei", sans-serif;
    background: #fff;
    height: 740px !important;
    max-height: 740px !important;
    overflow-y: scroll !important;
    overflow-x: hidden;
    scroll-behavior: smooth;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 0 5px rgba(0,0,0,0.05);
    position: relative;
    box-sizing: border-box;
    margin: 0;
    -webkit-overflow-scrolling: touch;
}

.agreement-title {
    background-color: #ffffff;
    color: rgb(0, 0, 0);
    padding: 0px;
    text-align: center;
    margin: 0;
    font-size: 22px;
    font-weight: normal;
    letter-spacing: 1px;
}

.agreement-content::-webkit-scrollbar {
    width: 8px;
}

.agreement-content::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    transition: all 0.3s;
}

.agreement-content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.5);
}

.agreement-content::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
}

.agreement-content::-webkit-scrollbar-corner {
    background: transparent;
}

/* 兼容Firefox */
@supports (-moz-appearance:none) {
    .agreement-content {
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.05);
    }
}

/* 兼容Edge */
@supports (-ms-ime-align:auto) {
    .agreement-content {
        -ms-overflow-style: auto;
    }
}
/* 移除重复的滚动条样式定义 */

section {
    margin-bottom: 30px;
    background: white;
    padding: 25px;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

h3 {
    margin: 0 0 20px;
    color: #1E88E5;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 8px;
    border-bottom: 2px solid #e0e0e0;
}

p {
    margin: 18px 0;
    font-size: 15px;
    text-align: justify;
    line-height: 1.4;
    color: #555;
    text-indent: 2em;
}

ol,
ul {
    margin: 18px 0;
    padding-left: 40px;
}

li {
    margin: 12px 0;
    line-height: 1.8;
    color: #555;
}

strong {
    color: #333;
    font-weight: bold;
}

@media (max-width: 768px) {
    .agreement-body {
        padding: 20px;
    }

    section {
        padding: 15px;
    }

    p {
        text-indent: 0;
        margin: 15px 0;
    }

    ol,
    ul {
        padding-left: 25px;
    }
}


</style>